// extracted by mini-css-extract-plugin
module.exports = {"iconButton":"IconButton_iconButton__2x4Qu","iconButtonSquare":"IconButton_iconButtonSquare__MRbeE"};